<template>
  <div>
    <div class="qy-header-wrapper">
      <div class="qy-header">企业</div>
      <div class="tab box">
        <div class="tab1 tab-item" @click="toList">列表</div>
        <div class="tab2 tab-item select" @click="toMap">地图</div>
        <div class="tab3 tab-item" @click="toTotal">统计</div>
      </div>
    </div>
    <div style="position: relative">
      <div class="map-wrapper" :style="{height:Height*0.882+'px'}" id="container">
      </div>
      <!--左上角的输入搜索-->
      <div class="input-qiye">
        <Input search enter-button placeholder="搜位置、企业" v-model="sousuo" @on-search="searchQiye"/>
        <ul v-if="qiyeTotal.length>0" class="qiyelist-wrapper" :style="{fontSize:Height>750 && Width > 1550?'15px':'13px'}">
          <li v-for="(item,index) in qiyeList" :key="index" class="qiye-item box" @click.stop="gotoDetail(item.id)" :id="index==0?'first':''">
            <div class="index-icon">{{index + 1}}</div>
            <div class="item-detail-wrapper">
              <div>{{item.name}}</div>
              <div class="box" style="align-items: center">
                <Rate allow-half v-model="item.score" disabled  />
                <div v-if="!item.score" style="color:#999;" >
                 （暂无评分）
                </div>
              </div>
              <div class="slh item-address">{{item.address}}</div>
              <div class="box" style="flex-wrap: wrap">
                <div v-for="(_item,_index) in item.type" :key="_index" class="item-type">
                  {{_item.name}}
                </div>
              </div>
            </div>
            <div class="item-img-wrapper">
              <img v-if="item.pic" class="item-img" :src="item.pic" >
              <div v-else class="item-img zhanwei" >暂无图片</div>
            </div>
          </li>
        </ul>
        <div v-if="qiyeTotal.length>0" class="page-wrapper">
          <Page class="page" :total="pageTotal" :page-size="rows" :current="page" @on-change="changePage"/>
        </div>
      </div>
      <!--右上角筛选列表-->
      <div class="btn-wrapper box">

        <div  v-if="isJiedao == 1" class="select-btn select-service-btn" :style="{color:showShequ?'#ff7b44':''}" @click="showShequList">
          <div class="box select-btn-text">
            组织区域
            <div class="iconfont xia icon-xiala" :class="{'changexia':showShequ}"></div>
          </div>
          <ul v-if="showShequ" class="service-list">
            <li v-for="(item,index) in childShequ" :key="index" class="box" @click.stop="selectShequ(item,index)">
              <i v-if="item.isSelect" class="iconfont icon-xuanzhong1 xuan"></i>
              <i v-else class="iconfont icon-xuanzhongkuang weixuan"></i>
              <div :style="{color:item.isSelect?'#ff7b44':''}">{{item.name}}</div>
            </li>
          </ul>
        </div>

        <div class="select-btn select-service-btn" :style="{color:showService?'#ff7b44':''}"@click="showServiceList">
          <div class="box select-btn-text">
            服务类型
            <div class="iconfont xia icon-xiala" :class="{'changexia':showService}"></div>
          </div>
          <ul v-if="showService" class="service-list">
            <li class="service-li box" v-for="(item,index) in serviceList" :key="index" @click.stop="showChild(item)">
              <i v-if="item.isSelect" class="iconfont icon-duoxuan1 xuan" @click.stop="selectService(item,index)"></i>
              <i v-else class="iconfont icon-duoxuankuang1 weixuan" @click.stop="selectService(item,index)"></i>
              <div :style="{color:item.isSelect?'#ff7b44':''}" class="service-name">{{item.name}}</div>
              <ul v-if="item.children.length>0 && item.childShow" class="service-child">
                <li v-for="(_item,_index) in item.children" :key="_index" class="box" @click.stop="showChild(_item)">
                  <i v-if="_item.isSelect" class="iconfont icon-duoxuan1 xuan" @click.stop="selectService(_item,index)"></i>
                  <i v-else class="iconfont icon-duoxuankuang1 weixuan" @click.stop="selectService(_item,index)"></i>
                  <div :style="{color:_item.isSelect?'#ff7b44':''}">{{_item.name}}</div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="select-btn" :style="{color:showQuan?'#ff7b44':''}" @click="showQuanList">
          <div class="box select-btn-text">
            圈选
            <div class="iconfont xia icon-xiala" :class="{'changexia':showQuan}"></div>
          </div>
          <ul v-if="showQuan" class="service-list">
            <li v-for="(item,index) in quanList" :key="index" class="box" @click.stop="selectQuan(item)">
              <i v-if="item.isSelect" class="iconfont icon-xuanzhong1 xuan"></i>
              <i v-else class="iconfont icon-xuanzhongkuang weixuan"></i>
              <div :style="{color:item.isSelect?'#ff7b44':''}">{{item.name}}</div>
            </li>
          </ul>
        </div>
      </div>
      <!--画完圈选后的编辑及清除按钮-->
      <div class="yuan-btn-wrapper" v-if="showBianjiBtn">
        <!--编辑按钮-->
        <div class="yuan-btn" style="background: #fd8853;margin-bottom: 10px" @click.stop="bianji">
          {{isBianjiBtn?'编辑':'取消编辑'}}
        </div>
        <!--清除按钮-->
        <div class="yuan-btn" style="background: #58bf63" @click="clear">清除</div>
      </div>
    </div>
  </div>
</template>

<script>

  var that,
      mouseTool,
      map,
      autoComplete,
      geocoder,
      markerList = [],
      locationlist=[],
    infoWindow//信息窗体
  export default {
    components: {

    },
    data () {
      return {
        Height:window.document.body.offsetHeight-60,
        Width:window.document.body.offsetWidth,
        selectServiceBtn:false,
        showService:false,//显示选择服务list
        showQuan:false,//显示选择圈选类型list
        serviceList:[],//服务类型集合
        quanList:[{
          name:'圆形',
          type:'circle',
          isSelect:false
        },{
          name:'多边形',
          type:'polygon',
          isSelect:false
        }],
        overlays:'',//遮盖物
        quanxuanData:'',//遮盖物数据 路径 半径等等
        type:'',
        drawFinish:true,
        showBianjiBtn:false,
        isBianjiBtn:true,
        shiliangtu:'',//画完的矢量图
        polyEditor:'',
        sousuo:'',//搜索的企业名称
        searchList:[],//搜索的结果
        selectZuobiao:'',//搜索的企业的坐标
        qiyeList:[],//查询的当前页码的企业
        page:1,
        rows:10,
        rule: {
          typeIdList: [], //企业类型ID集合
          serviceIdList: [], //服务类型ID集合
          companyName: "" ,//查询企业名称
          address:"",//查询企业地址
          communityIdList:[this.$store.state.streetorcommunityid],
          checkInfo: {status: 1}
        }, // 过滤器筛选类型
        pageTotal:0,
        zuobiaoList:[],//查询的企业的坐标集合
        qiyeTotal:[],//查询的所有企业
        changeMaxPage:1,
        // allQiye:false,//查询所有企业  圈选用
        childShequ:[],//行政区域
        showShequ:false,
        currentComunityId:this.$store.state.streetorcommunityid,
      }
    },
    computed :{
      isJiedao () {
        return this.$store.state.isJiedao;
      },
    },
    watch:{
      sousuo (newValue,oldValue) {
        if (!newValue) {
          that.qiyeList = []
        }
      }
    },
    methods:{
      toList () {
        this.$router.push({name:'userEnterprise'})
      },
      toMap () {
        return
      },
      toTotal () {
        this.$router.push({name:'qiyeTotal'})
      },
      handleResize (event) {
        console.log('刷新')
        this.Width = document.documentElement.clientWidth
        this.Height = document.documentElement.clientHeight -60
        // that.reload();
      },
      initMap () {
        map = new AMap.Map('container',{
          zoom: 15,  //设置地图显示的缩放级别
          // center: [116.396923,39.918203],//设置地图中心点坐标
          // layers: [new AMap.TileLayer.Satellite()],  //设置图层,可设置成包含一个或多个图层的数组
          mapStyle: 'amap://styles/normal',  //设置地图的显示样式
          viewMode: '2D',  //设置地图模式
          lang:'zh_cn',  //设置地图语言类型
        });
        //逆地理编码
        geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: '010'
        })
        var center = ''
        var didian = ''
        map.plugin('AMap.Geolocation', function() {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
            // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
            // buttonOffset: new AMap.Pixel(10, 20),
            //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            zoomToAccuracy: true,
            //  定位按钮的排放位置,  RB表示右下
            buttonPosition: 'RB'
          })
          geolocation.getCurrentPosition((status,result) => {
            if (status == 'complete') {
              center = [result.position.lng,result.position.lat]
              map.setCenter(center)
              geocoder.getAddress(center, function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                  // result为对应的地理位置详细信息
                  didian = result.regeocode.formattedAddress
                  var text = new AMap.Text({
                    text:'我在 '+didian+' 这',
                    anchor:'center', // 设置文本标记锚点
                    style:{
                      'padding': '5px 10px',
                      'border-radius': '4px',
                      'background-color': 'white',
                      // 'width': '15rem',
                      // 'border-width': 0,
                      'box-shadow': '0px 2px 10px 1px #9f9e9a',
                      'text-align': 'center',
                      'font-size': '15px',
                      'color': '#333',
                    },
                    offset: new AMap.Pixel(0, -40),
                    position: center
                  });
                  text.setMap(map)
                }
              })
              var circleMarker = new AMap.CircleMarker({
                center:center,
                radius:10,//3D视图下，CircleMarker半径不要超过64px
                strokeColor:'#4685e6',
                strokeOpacity:1,
                fillColor:'#4685e6',
                fillOpacity:1,
                bubble:true,
              })
              circleMarker.setMap(map)
            }

          })
          AMap.event.addListener(geolocation, 'complete', onComplete)
          AMap.event.addListener(geolocation, 'error', onError)

          function onComplete (data) {
            // data是具体的定位信息
          }

          function onError (data) {
            // 定位出错
          }
        })

        //查询
        autoComplete= new AMap.Autocomplete(autoOptions);


        map.on('complete', function(){
          // 地图图块加载完成后触发
        });
        map.on('click', function(ev) {
          // 触发事件的对象
          console.log(ev)
          var obj = {
            lng:ev.lnglat.lng,
            lat:ev.lnglat.lat,
          }
        locationlist.push(obj)
        console.log(locationlist)
          var target = ev.target;
          // 触发事件的地理坐标，AMap.LngLat 类型
          var lnglat = ev.lnglat;
          // 触发事件的像素坐标，AMap.Pixel 类型
          var pixel = ev.pixel;
          // 触发事件类型
          var type = ev.type;
        });

        var autoOptions = {
          //city 限定城市，默认全国
          city: '全国'
        }
      },
      //显示 隐藏组织区域列表
      showShequList () {
        this.showShequ = !this.showShequ
      },
      //选择组织区域
      selectShequ (shequ,index) {
        console.log(shequ, index)
        this.childShequ.forEach(item => {
          if (item.id == shequ.id) {
            item.isSelect = true
            var index = String(item.id).indexOf(',')
            var idlist = index == -1 ? [item.id] : item.id.split(',')
            this.rule.communityIdList = idlist
          }
          else item.isSelect = false
        })
        // return
        this.rule.serviceIdList = []

        if (markerList) map.remove(markerList)
        that.qiyeTotal = []
        that.changeMaxPage = 1
        markerList = []
        that.page = 1
        // this.getLabel()
        this.getQiye()
      },
      //显示 隐藏服务列表
      showServiceList () {
        this.showService = !this.showService
      },
      //选择服务类型
      selectService (item,index) {
        that.showBianjiBtn = false
        item.isSelect = !item.isSelect
        if (index == that.serviceList.length-1 && !item.isSelect) {
          that.serviceList.forEach(item => {
            if (item.children.length) {
              item.children.forEach(child => {
                child.isSelect = false
              })
            }
            item.isSelect = false
          })
        }else if (index == that.serviceList.length-1 && item.isSelect) {
          that.serviceList.forEach(item => {
            if (item.children.length) {
              item.children.forEach(child => {
                child.isSelect = true
              })
            }
            item.isSelect = true
          })
        }
        if (that.serviceList[index].children.length > 0 && item.children.length==0 && !item.isSelect) {
          that.serviceList[index].isSelect = false
        }
        if (that.serviceList[index].children.length > 0 && item.children.length==0 && item.isSelect) {
          that.serviceList[index].isSelect = true
          that.serviceList[index].children.forEach(res => {
            if (!res.isSelect) {
              that.serviceList[index].isSelect = false
              return
            }
          })
        }
        if (item.children.length > 0) {
          if (item.isSelect) {
            item.childShow = true
            item.children.forEach(data => {
              data.isSelect = true
            })
          }else {
            item.children.forEach(data => {
              data.isSelect = false
            })
          }
        }
        var list = []
        that.serviceList.forEach(item => {
          if (item.children.length > 0) {
            item.children.forEach(child_item => {
              if (child_item.isSelect) {
                list.push(child_item.id)
              }
            })
          }else {
            if (item.isSelect) {
              list.push(item.id)
            }
          }
        })
        if (markerList) map.remove(markerList)
        that.qiyeTotal = []
        that.changeMaxPage = 1
        markerList = []
        that.page = 1
        that.rule.serviceIdList = list
        if (list.length == 0) return
        that.getQiye()
      },
      //隐藏 显示 圈选类型列表
      showQuanList () {
        this.showQuan = !this.showQuan
        if (!this.showQuan) {
          that.clear()
          if ( mouseTool) mouseTool.close()//关闭
          this.quanList.forEach(item => {
            item.isSelect = false
          })
        }
      },
      //选择圈选类型
      selectQuan (data) {
        that.polyEditor = ''
        if ( mouseTool) mouseTool.close()//关闭
        this.quanList.forEach(item => {
          if (item.type == data.type) {
            if (!item.isSelect)  map.remove(that.overlays)
            item.isSelect = true
          }else{
            item.isSelect = false
          }
        })
        if (data.type != that.type) {
          that.showBianjiBtn = false
          that.type = data.type
          that.initmouseTool()
        }
      },
      showChild (data) {
        if (data.children.length > 0) {
          data.childShow = !data.childShow
        }else {
          return
        }
      },
      initmouseTool () {
        mouseTool = new AMap.MouseTool(map);
        //监听draw事件可获取画好的覆盖物
        var overlays = [];
        mouseTool.on('draw',function(e){
          that.shiliangtu = e.obj
          if (that.type == 'polygon') {
            console.log('矩形')
            console.log(e.obj.getBounds())
            that.quanxuanData = e.obj.getPath()
          }else if (that.type == 'circle') {
            map.setCenter(e.obj.getCenter())//居中

            that.yuanData = {
              center:e.obj.getCenter(),
              radius:e.obj.getRadius()
            }
          }
          console.log('关闭')
          mouseTool.close()//关闭
          overlays.push(e.obj);
          console.log(overlays)
          that.overlays = overlays
          that.showBianjiBtn = true
          console.log(locationlist)
          console.log(JSON.stringify(locationlist))
          // console.log(map.getPath())
          that.quanxuanQiye()
        })
        switch (that.type) {
          case 'circle': {
            mouseTool.circle({
              fillColor: '#ed4015',
              strokeColor: '#ed4015'
              //同Circle的Option设置
            });
            break;
          }
          case 'polygon':{
            mouseTool.polygon({
              fillColor:'#ed4015',
              strokeColor:'#ed4015',
              draggable:true,
              // strokeStyle:'dashed'
              //同Polygon的Option设置
            });
            break;
          }
        }
      },
      quanxuanQiye () {
        console.log('处理圈选完后数据')
        if (markerList) map.remove(markerList)
        markerList = []
        that.zuobiaoList=[]
        that.qiyeTotal = []
        that.page = 1
        var shiliangtu = that.shiliangtu
        let url = this.urlobj.getQyList;
        var reg = /[0-9]+.[0-9]+/g;
        this.$post(url, {
          pageNum: 0,
          pageSize: 0,
          ...that.rule
        }).then(res => {
          var qiyeTotal = []
          var data = res.rows.filter(item => {
            return item.coordinate && shiliangtu.contains(item.coordinate.match(reg))
          })

          that.pageTotal = data.length
          console.log(data)
          if (data.length > 0) {
            for (var i=0; i<data.length; i++) {
              qiyeTotal.push({
                id:data[i].id,
                dian:data[i].companyServiceList && data[i].companyServiceList[0].dropPicUrl?data[i].companyServiceList[0].dropPicUrl:'//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                name:data[i].companyName,
                address:data[i].address,
                pic:data[i].headPicUrl == null?'':data[i].headPicUrl,
                type:data[i].companyAttrList !=null?data[i].companyAttrList.map(_item => {
                  return {
                    name:_item.propertyName,
                    id:_item.propertyId
                  }
                }):[],
                zuobiao:data[i].coordinate.match(reg).join(",")
              })
            }
            console.log(qiyeTotal)
            that.qiyeTotal = qiyeTotal
            // that.qiyeList = that.qiyeTotal.slice(0,that.rows)
            that.qiyeList = qiyeTotal
            that.setMarkers(qiyeTotal)
          }
        })
      },
      bianji () {
        var shiliangtu = that.shiliangtu
        if (that.type == 'polygon' && !that.polyEditor) {
          var polyEditor = new AMap.PolyEditor(map, shiliangtu)
          polyEditor.on('end', (event) => {
            that.shiliangtu = event.target
            that.polyEditor = ''
          })
          that.polyEditor = polyEditor
        }else if (that.type == 'circle' && !that.polyEditor) {
          var polyEditor = new AMap.CircleEditor(map, shiliangtu)
          polyEditor.on('end', (event) => {
            that.shiliangtu = event.target
            that.polyEditor = ''
          })
          that.polyEditor = polyEditor
        }
        if (that.isBianjiBtn) {//现在显示的是编辑，点击后进入编辑状态
          that.isBianjiBtn  = false
          shiliangtu.setOptions({
            strokeStyle:'dashed'
          })
          that.polyEditor.open()
        }else {
          that.isBianjiBtn  = true
          shiliangtu.setOptions({
            strokeStyle:'solid'
          })
          that.polyEditor.close()
        }
        that.quanxuanQiye()
      },
      clear () {
        if (markerList) map.remove(markerList)
        markerList = []
        that.zuobiaoList = []
        that.qiyeTotal = []
        map.remove(that.overlays)
        that.showBianjiBtn = false
        that.initmouseTool()
      },
      //查询服务类型 (标签)
      getLabel (){
        var url = this.urlobj.getQyLabel
        this.$get(url, {
          labelParentType: "service",
          communityIds: this.rule.communityIdList.join(",")
        }).then(res => {
          this.serviceList = res.rows.map(item => {
            return {
              isSelect:false,
              name:item.dicName,
              id:item.id,
              children:item.children.map(_item => {
                return {
                  isSelect:false,
                  name:_item.dicName,
                  id:_item.id,
                  childShow:false,
                  children:[]
                }
              }),
              childShow:true,
            }
          })
          this.serviceList.push({
            isSelect:false,
            name:'全部',
            id:996,
            children:[],
            childShow:true
          })
        })
      },
      //获取行政区域
      getChildShequ () {
        var url = this.urlobj.getDivision('company')
        this.$get(url).then(res => {
          var num = 0
          var ids = []
          var counts = []
          ids = res.rows.map(item => {
            return item.communityId
          })
          var item1 = {
            name: '全部',
            id: ids.join(','),
            isSelect: false
          }
          var list = res.rows.map(item => {
            return {
                name: item.communityName,
                id: item.communityId,
                isSelect: item.communityId == this.$store.state.streetorcommunityid
            };
          })
          list.unshift(item1)
          console.log(list)
          that.childShequ = list
        })
      },
      //搜索企业
      searchQiye () {
        // autoComplete.search(that.sousuo, function(status, result) {
        //   // 搜索成功时，result即是对应的匹配数据
        //   that.searchList = result.tips
        // })
        this.page = 1
        this.qiyeTotal = []
        if (markerList) map.remove(markerList)
        markerList = []
        this.rule.companyName = this.sousuo
        this.rule.address = this.sousuo
        this.getQiye()
      },
      changePage (value) {
        that.page = value
        this.getQiye()
        // that.qiyeList = that.qiyeTotal.slice((that.page-1)*that.rows,(that.page-1)*that.rows+that.rows)
        // that.setMarkers(that.qiyeList)


        // if (that.changeMaxPage < value) {
        //   this.page = value
        //   that.changeMaxPage = value
        //   if (this.allQiye) {
        //     that.qiyeList = that.qiyeTotal.slice((that.page-1)*that.rows,(that.page-1)*that.rows+that.rows)
        //   }else {
        //     this.getQiye()
        //   }
        // }else {
        //   that.page = value
        //   that.qiyeList = that.qiyeTotal.slice((that.page-1)*that.rows,(that.page-1)*that.rows+that.rows)
        // }
      },
      getQiye () {
        let url = this.urlobj.getQyList;
        var reg = /[0-9]+.[0-9]+/g;
        this.$post(url, {
          pageNum: that.page,
          pageSize: that.rows,
          ...that.rule
        }).then(res => {
          that.pageTotal = res.total
          let qiyeTotal = []
          for (var i=0; i<res.rows.length; i++) {
            var zuobiao = ''
            if (res.rows[i].coordinate && res.rows[i].coordinate != '' && res.rows[i].coordinate != '{}') {
              var xy = res.rows[i].coordinate.match(reg)
              console.log(xy)
              if(xy) zuobiao = xy.join(",")
            }
            qiyeTotal.push({
              dian:res.rows[i].companyServiceList && res.rows[i].companyServiceList[0].dropPicUrl?res.rows[i].companyServiceList[0].dropPicUrl:'//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
              id:res.rows[i].id,
              name:res.rows[i].companyName,
              address:res.rows[i].address,
              pic:res.rows[i].headPicUrl == null?'':res.rows[i].headPicUrl,
              type:res.rows[i].companyAttrList !=null?res.rows[i].companyAttrList.map(_item => {
                return {
                  name:_item.propertyName,
                  id:_item.propertyId
                }
              }):[],
              zuobiao,
              score:res.rows[i].avgScore == null?0:parseFloat(((res.rows[i].avgScore)/100).toFixed(1)),
            })
            

            console.log(qiyeTotal)
          }
          that.qiyeTotal = qiyeTotal
          // that.qiyeList = that.qiyeTotal.slice((that.page-1)*that.rows,(that.page-1)*that.rows+that.rows)
          that.qiyeList = qiyeTotal
          that.setMarkers(that.qiyeList)
          if (qiyeTotal.length) document.getElementById("first").scrollIntoView();
        })
      },
      setMarkers (list) {
        if (markerList) map.remove(markerList)
        markerList =[]
        list.forEach((item,index) => {
          if (item.zuobiao) {
            var marker = new AMap.Marker({
              position: new AMap.LngLat(item.zuobiao.split(',')[0],item.zuobiao.split(',')[1]),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              icon: item.dian,
            })
            marker.id = item.id
            marker.lng = item.zuobiao.split(',')[0]
            marker.lat = item.zuobiao.split(',')[1]
            marker.name = item.name
// 自定义点标记内容
            var markerContent = document.createElement("div");

            // 点标记中的图标
            var markerImg = document.createElement("img");
            markerImg.className = "markerlnglat";
            markerImg.src = item.dian;
            markerImg.setAttribute("style","width:30px;height:40px")
            markerContent.appendChild(markerImg);
            // 点标记中的文本
            var markerSpan = document.createElement("span");
            markerSpan.className = 'marker';
            markerSpan.innerHTML = index+1;
            markerContent.appendChild(markerSpan);
            markerSpan.setAttribute("style","color:#fff;font-size:19px;position:absolute;top:0px;width: 30px;display:flex;justify-content:center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;");
            marker.setContent(markerContent); //更新点标记内容
            marker.on('click',that.clickMarker)
            marker.on('mouseover',that.overMarker)
            marker.on('mouseout',that.outMarker)
            markerList.push(marker)
          }
        })
        if (markerList.length > 0) {

          map.add(markerList)
          map.setCenter(markerList[0].getPosition())
        }
      },
      clickMarker (e) {
        this.gotoDetail(e.target.id)
      },
      overMarker (e) {
        var name = e.target.name
        var title = ''
        // var content = [`<div>$name</div>`]
        //构建自定义信息窗体
        infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -35),
          isCustom: true,  //使用自定义窗体
          content: that.createInfoWindow(title, name),
        });
        infoWindow.open(map,[e.target.lng,e.target.lat])
      },
      createInfoWindow (title,name) {
        var info = document.createElement("div");
        info.innerHTML = name
        info.setAttribute("style","height:30px;background:#fff;padding: 5px 10px;border-radius: 5px;box-shadow: 0px 0px 5px #999;")
        return info
      },
      outMarker () {
        infoWindow.close()
      },
      gotoDetail (id) {
        this.$router.push({ name: "qiyeDetail", query:{companyId:id, status:1}});
      },
      // selectSearch (value) {
      //   var data = that.searchList[value]
      //   that.sousuo=data.name
      //   that.selectZuobiao = [data.location.lat,data.location.lng]
      //   console.log(that.selectZuobiao)
      // }
    },

    mounted () {
      that = this
      window.addEventListener('resize', this.handleResize)
      this.Height = window.document.body.offsetHeight-60
      this.Width = window.document.body.offsetWidth
      this.getLabel()
      this.getChildShequ()
      this.initMap()
      this.getQiye()
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    destroyed () {
      map.destroy()
    }
  }
</script>

<style scoped>
  .qy-header-wrapper {
    display: flex;
    /*height: 30px;*/
    line-height: 30px;
    padding-top: 30px;
    justify-content: center;
    position: relative;
    margin-bottom: 30px;
  }
  .qy-header {
    font-size: 25px;
    text-align: center;
  }
  .tab{
    position: absolute;
    left:20px;
    background: #fff;
    color: #a0a0a0;
    border-radius: 5px;
    font-size: 14px;
  }
  .tab1{
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
  }
  .tab2{
    border-right: 1px solid #eee;
    border-left: 1px solid #eee;
  }
  .tab3{
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;

  }
  .tab-item{
    /* width: 50px; */
    text-align: center;
    height: 35px;
    line-height: 35px;
    cursor: default;
    padding:0 15px
  }
  .select{
    background: #ff7b44;
    color:#fff
  }
  .map-wrapper{
    margin:0 auto;
    width: 97.7%;
    background: #fff;
  }
  .btn-wrapper{
    position: absolute;
    right:40px;
    top:20px;
    background: #fff;
    color:#a0a0a0;
    border-radius: 5px;
    z-index: 100;
    box-shadow: 0px 3px 10px 0px #9f9e9a;
  }
  .select-btn{
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .select-service-btn{
    border-right: 1px solid #f2f2f2;
    width: 155px;
  }
  .service-list{
    background: #fff;
    border-radius:5px;
    margin-top:5px;
    color:#333;
    padding-left:10px;
    box-shadow: 0px 3px 10px 0px #9f9e9a;
  }
  .service-li{
    flex-wrap: wrap;
  }
  .service-name{
    width: 80%;
    text-align: left;
  }
  .service-child{
    padding-left:30px
  }
  .xuan{
    color:#ff7b44;
    font-size:12px;
    margin-right:10px
  }
  .weixuan{
    color:#ddd;
    font-size:12px;
    margin-right:10px
  }
  .yuan-btn-wrapper{
    position: absolute;
    right: 90px;
    top:400px;
    color:#fff;
  }
  .yuan-btn{
    height: 50px;
    width: 50px;
    border-radius: 100%;
    box-shadow: 0px 2px 10px 1px #9f9e9a;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    padding: 10px;
  }
.input-qiye{
  position: absolute;
  left:40px;
  top:20px;
  width: 440px;
}
.auto-complete{
  flex:1;
  height: 40px;
}
.sousou-btn{
  background: #ff7b44;
  color:#fff;
  width: 60px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.qiyelist-wrapper{
  background: #fff;
  color: #ff7b44;
  border-radius: 4px;
  margin-top: 10px;
  /*font-size: 15px;*/
  padding: 0 20px;
  height: 400px;
  overflow-y: scroll;
  position: relative;
}
  /*.qiyelist-wrapper::-webkit-scrollbar {*/
    /*width: 0;*/
  /*}*/
.qiye-item{
  padding-top: 30px;
}
.index-icon{
  width: 30px;
  height: 40px;
  background-image: url("../../assets/images/dingwei.png");
  background-repeat: no-repeat;
  margin-right:10px;
  text-align: center;
  color:#fff;
  padding-top:2px;
  flex-shrink: 0;
}
.item-detail-wrapper{
  flex:1
}
.item-img-wrapper{
  /*padding-top:30px*/
}
.item-address{
  color:#999;
  padding-top:10px;
  padding-bottom: 20px;
  max-width: 270px;

}
.item-type{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  color: #fda52a;
  background: #fef0e5;
  border-radius: 5px;
  margin-right: 10px;
  font-size: 11px;
  margin-bottom:10px;
}
.item-img{
  width: 80px;
  height: 80px;
}
.page-wrapper{
  background: #fff;
  border-top: 1px solid #eee;
}
.page{
  padding:20px 0 20px;
  display: flex;
  justify-content: center;
}
.custom-content-marker {
  position: relative;
  width: 25px;
  height: 34px;
}
  .custom-content-marker .ditu-icon{
  width: 100px;
  height: 30px;
  padding:5px 10px;
  background: #fff;
  box-shadow: 0px 2px 10px 1px #9f9e9a;
}
.zhanwei{
  border:1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:14px;
  color:#999
}
  .select-btn-text{
    justify-content: center;
  }
  .xia{
    margin-left: 10px;
  }
  .changexia{
    transform: rotate(180deg);
  }
</style>
